<div class="mb-2">
  
  @if(crmService.wizardLoading().isLoadingWizardStepAction){
  <zint-loader size="small" [overlay]="true" [dotColor]="'var(--zint-grey-500)'"></zint-loader>
  }
  <span class="text-bold-600 mb-1">Map Zint "UK Company Number" to {{crmType | titlecase}} Field:
  </span>
  <zint-autocomplete [options]="crmLookupFields" [displayProperty]="'label'" label="Select the {{crmType | titlecase}} field that stores the UK Company Registration Number" [preSelectedValue]="existingLookupField" [showIcon]="true" (optionSelected)="postChoiceAndGetStatus($event)"></zint-autocomplete>  
  
</div>

@if (lookupFieldID) {  
<details class="">  
  <summary class="text-grey-600 u-offset-25">Advanced Lookup Options (Optional)</summary>
  @for (item of allLookupTransformOptions; track $index) {
    <div class="zint-base-card w-50 d-flex justify-content-between mb-1">
      <span>{{item.label}}
        <small class="text-sup" role="button" matTooltip="Help" (click)="toggleAdvancedOptionModal()">
          <i class="fas fa-circle-info text-vivid-blue"></i>
        </small>
      </span>
      @if (crmService.wizardLoading().isLoadingWizardStepAction) {
      <zint-loader size="xSmall"></zint-loader>
      }
      <mat-slide-toggle [color]="'primary'" [checked]="item.checked" (change)="setTransformOption(item, $event.checked)">
      </mat-slide-toggle>
    </div>
  }
</details>
}

@if (showAdvancedOptionsModal) {
  <zint-modal [modalConfig]="advancedHelpModalConfig" [modalContent]="advancedHelpModalContent"></zint-modal>
}
